import { Box, Chip, Tooltip } from '@mui/material';

import type { DesktopNotificationPlaceholderDto } from '@/api/types/desktopNotification.types';

interface PlaceholderChipsProps {
  tokens: DesktopNotificationPlaceholderDto[];
  onInsert: (token: string) => void;
}

export function PlaceholderChips({ tokens, onInsert }: PlaceholderChipsProps) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {tokens.map(({ token, description }) => (
        <Tooltip key={token} title={description || token}>
          <Chip
            label={token}
            size="small"
            variant="outlined"
            color="secondary"
            clickable
            onClick={() => onInsert(token)}
            aria-label={`Insert placeholder ${token}`}
          />
        </Tooltip>
      ))}
    </Box>
  );
}

export default PlaceholderChips;
